import React from "react";

function ReservationConfirmation() {
    return (
        <div className="alertMessage">
            <p className="paragraphText">Reservation Confirmed</p>
        </div>
    );
}

export default ReservationConfirmation;